<template>
  <div class="wp">
    <div class="header">
      <div class="header-content">
        <img class="logo" src="https://smsycs.hxxpl.com.cn/2020/202007080959359089774.png" alt="文旅" />
        <!-- <div class="menu">
          <p>首页</p>
          <p>应用</p>
          <p>关于</p>
        </div>-->
      </div>
    </div>
    <div class="loop-box">
    </div>
    <div class="login-box">
      <div class="login-head" v-if="type == '1' || type == '2'">
        <!-- <div class="login-head-title" :class="{active: type == '1'}"> -->
        <div class="login-head-title">
          <p @click="onClick_selectLogin" id="1" style="color:#2F72ED">密码登陆</p>
        </div>
        <!-- <div class="login-head-title" :class="{active: type == '2'}">
          <p @click="onClick_selectLogin" id="2">手机登录</p>
        </div>-->
      </div>
      <div class="login-head" v-if="type == '3' || type == '4'">
        <div class="login-head-title" :class="{active: type == '3'}">
          <p @click="onClick_selectLogin" id="3">供应商</p>
        </div>
        <div class="login-head-title" :class="{active: type == '4'}">
          <p @click="onClick_selectLogin" id="4">分销商</p>
        </div>
      </div>
      <div class="login-content" v-if="type == '3' || type == '4'">
        <div class="login-column" :class="{active: inputName == 'username' }">
          <img
            v-show="inputName == 'username'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459134469664.png"
          />
          <img
            v-show="inputName != 'username'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459191657132.png"
          />
          <input
            type="text"
            v-model="userName"
            id="username"
            @focus="focus"
            @blur="blur"
            placeholder="请输入您的用户名"
          />
        </div>
        <div class="login-column" :class="{active: inputName == 'password' }">
          <img
            v-show="inputName == 'password'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459014157166.png"
          />
          <img
            v-show="inputName != 'password'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459058063489.png"
          />
          <input
            type="password"
            v-model="password"
            id="password"
            @focus="focus"
            @blur="blur"
            placeholder="请输入您的密码"
          />
        </div>
        <div class="login-column" :class="{active: inputName == 'repassword' }">
          <img
            v-show="inputName == 'repassword'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459014157166.png"
          />
          <img
            v-show="inputName != 'repassword'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459058063489.png"
          />
          <input
            type="text"
            v-model="repassword"
            id="repassword"
            @focus="focus"
            @blur="blur"
            placeholder="请再次输入您的密码"
          />
        </div>
        <div class="registered" @click="onClcik_registered">注册</div>
        <p class="login-tips">
          已有账号，
          <span class="gologin-btn" @click="onClick_goLogin">直接登录</span>
        </p>
      </div>
      <div class="login-content" v-if="type == '1'">
        <div class="login-column" :class="{active: inputName == 'username' }">
          <img
            v-show="inputName == 'username'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459134469664.png"
          />
          <img
            v-show="inputName != 'username'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459191657132.png"
          />
          <input
            type="text"
            v-model="userName"
            id="username"
            @focus="focus"
            @blur="blur"
            placeholder="请输入您的用户名"
          />
        </div>
        <div class="login-column" :class="{active: inputName == 'password' }">
          <img
            v-show="inputName == 'password'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459014157166.png"
          />
          <img
            v-show="inputName != 'password'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459058063489.png"
          />
          <input
            type="password"
            v-model="password"
            id="password"
            @focus="focus"
            @blur="blur"
            placeholder="请输入您的密码"
          />
        </div>
        <div class="login-column last">
          <drag-verify
            :width="width"
            :height="height"
            :text="text"
            :success-text="successText"
            :background="background"
            :progress-bar-bg="progressBarBg"
            :completed-bg="completedBg"
            :handler-bg="handlerBg"
            :handler-icon="handlerIcon"
            :text-size="textSize"
            :success-icon="successIcon"
            :circle="getShape"
            ref="Verify"
            @passcallback="onClick_scroll"
          ></drag-verify>
        </div>
        <!-- <div class="registered" @click="reset">登录</div> -->
        <div class="registered" @click="onClcik_login">登录</div>
        <p class="login-tips">
          <span class="goregistered" @click="onClcik_goRegistered">立即注册</span>
          <span class="goresetpassword" @click="onClick_goLogin">忘记密码</span>
        </p>
      </div>
      <div class="login-content" v-if="type == '2'">
        <div class="login-column" :class="{active: inputName == 'phonenumber' }">
          <img
            v-show="inputName == 'phonenumber'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459134469664.png"
          />
          <img
            v-show="inputName != 'phonenumber'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459191657132.png"
          />
          <input
            type="text"
            v-model="userName"
            id="phonenumber"
            @focus="focus"
            @blur="blur"
            placeholder="请输入您的手机号"
          />
        </div>
        <div class="login-column last">
          <drag-verify
            :width="width"
            :height="height"
            :text="text"
            :success-text="successText"
            :background="background"
            :progress-bar-bg="progressBarBg"
            :completed-bg="completedBg"
            :handler-bg="handlerBg"
            :handler-icon="handlerIcon"
            :text-size="textSize"
            :success-icon="successIcon"
            :circle="getShape"
            ref="Verify"
            @passcallback="onClick_scroll"
          ></drag-verify>
        </div>
        <div class="login-column" :class="{active: inputName == 'captcha' }">
          <img
            v-show="inputName == 'captcha'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459014157166.png"
          />
          <img
            v-show="inputName != 'captcha'"
            src="https://smsycs.hxxpl.com.cn/2020/202006091459058063489.png"
          />
          <input
            type="number"
            v-model="password"
            id="captcha"
            @focus="focus"
            @blur="blur"
            placeholder="请输入您的验证码"
          />
          <div class="send" @click="onClick_sendCode">发送验证码</div>
        </div>
        <div class="registered" @click="reset">登录</div>
        <!-- <div class="registered" @click="onClcik_login">登录</div> -->
        <p class="login-tips">
          <span class="goregistered" @click="onClcik_goRegistered">立即注册</span>
          <span class="goresetpassword" @click="onClick_goLogin">忘记密码</span>
        </p>
      </div>
    </div>
    <div class="footer">Copyright © 2020 文旅中国分时预约及监测系统 Corporation, All Rights Reserved</div>
    <!-- <div class="float-icon">
      <div class="float-kf">
        <img class="white" src="https://smsycs.hxxpl.com.cn/2020/202006091458405096788.png" alt />
        <img class="bule" src="https://smsycs.hxxpl.com.cn/2020/202006091458133376896.png" alt />
        <p>QQ：111111111111</p>
      </div>
      <div class="float-phone">
        <img class="bule" src="https://smsycs.hxxpl.com.cn/2020/202006091458227594608.png" alt />
        <img class="white" src="https://smsycs.hxxpl.com.cn/2020/202006091458338532321.png" alt />
        <p>联系电话111111111111</p>
      </div>
    </div>-->
  </div>
</template>

<script>
import Vue from "vue";
import dragVerify from "vue-drag-verify";

export default {
  data() {
    return {
      swiper: [
        "https://smsycs.hxxpl.com.cn/2020/202006091515436501132.jpg",
        "https://smsycs.hxxpl.com.cn/2020/202006091515551969687.jpg",
        "https://smsycs.hxxpl.com.cn/2020/202006091515490876880.jpg",
        "https://smsycs.hxxpl.com.cn/2020/202006091515436501132.jpg"
      ],
      type: "1",
      userName: "",
      password: "",
      repassword: "",
      inputName: "",
      width: 400,
      height: 46,
      text: "请按住滑块，拖到最右边",
      successText: "验证成功",
      background: "#EEF0F5",
      progressBarBg: "#FFFF99",
      getShape: false,
      completedBg: "#66cc66",
      handlerBg: "#fff",
      handlerIcon: "-",
      textSize: "20",
      successIcon: "-",
      isPassing: false
    };
  },
  components: {
    dragVerify
  },
  created() {},
  modules() {},
  methods: {
    handleClick() {},
    onClick_selectLogin(e) {
      let id = e.target.id;
      if (id == this.type) {
        return;
      }
      this.type = id;
      this.reset();
    },
    done(e) {
      console.log(e);
    },
    focus(e) {
      let id = e.target.id;
      this.inputName = id;
    },
    blur(e) {
      let id = e.target.id;
      this.inputName = "";
    },
    onClcik_registered() {
      if (!this.userName) {
      }
    },
    onClick_goLogin() {
      this.type = "1";
    },
    onClcik_goRegistered() {
      this.type = "3";
    },
    onClcik_login() {
      console.log(this.$refs.Verify.isPassing);
      if (!this.userName) {
        this.$message.error('请输入用户名');
        return;
      }
      if (!this.password) {
        this.$message.error('请输入密码');
        return;
      }
      if (!this.$refs.Verify.isPassing) {
         this.$message.error('请完成滑动验证');
        return;
      }
      var that = this;

      this.$http
        .post("/home/GetTourismChina", {
          userName: this.userName,
          passWord: this.password
        })
        .then(res => {
          console.log(res);
          if (res.data.Code == 0) {
            this.$message.error(res.data.Message);
            this.reset();
          } else {
            // this.$message({
            //   type: "success",
            //   message: "登录成功"
            // });
            location.href = res.data.Data;
          }
        });
    },
    onClick_scroll(res) {
      this.isPassing = true;
    },
    reset() {
      this.isPassing = false;
      // if (this.$refs.dragVerify != undefined) {
      //   this.$refs.dragVerify.reset();
      // }

      this.$refs.Verify.isMoving = false;
      this.$refs.Verify.isPassing = false;
      this.$refs.Verify.x = 0;
      this.$refs.Verify.$refs.handler.style.left = "0";
      this.$refs.Verify.$refs.progressBar.style.width = "0";
    },
    onClick_sendCode() {}
  },
  watch: {}
};
</script>

<style type="text/css" scoped>
@import "./login.css";
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue